(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Compare_with_blocks"] && !Shopify.designMode) return;
  try {
    

document.addEventListener('DOMContentLoaded', function() {
  const swatchLabels = document.querySelectorAll('.swatch-label');
  
  swatchLabels.forEach(label => {
    const colorName = label.getAttribute('data-color-name').toLowerCase();
    let colorCode;

    // Define color codes for common color names
    switch (colorName) {
      case 'ash':
        colorCode = '#a3a3a3';
        break;
      case 'weiß':
        colorCode = '#ffffff';
        break;
      case 'sleepy sage':
        colorCode = '#AFBFBA';
        break;
      case 'bedtime blue':
        colorCode = '#527690';
        break;
      case 'dusty rose':
        colorCode = '#B89A94';
        break;
      case 'nachtblau':
        colorCode = '#5E7185';
        break;
      case 'rose':
        colorCode = '#D4B5B0';
        break;
      case 'sky':
        colorCode = '#4cbbb8';
        break;
      case 'pop':
        colorCode = '#e43e23';
        break;
      case 'red':
        colorCode = '#e52824';
        break;
      case 'jet':
        colorCode = '#000000';
        break;
      case 'gum':
        colorCode = '#eb5799';
        break;
      case 'hot':
        colorCode = '#ff0073';
        break;
      case 'mud':
        colorCode = '#4a342c';
        break;
      case 'tan':
        colorCode = '#d2b48c';
        break;
      case 'ruby':
        colorCode = '#e32040';
        break;
      case 'jade':
        colorCode = '#1b5c1d';
        break;
      case 'vert':
        colorCode = '#489c4a';
        break;
      case 'bone':
        colorCode = '#dedbbf';
        break;
      case 'aqua':
        colorCode = '#00ffff';
        break;
      case 'blue':
        colorCode = '#1d5caa';
        break;
      case 'cyan':
        colorCode = '#00ffff';
        break;
      case 'dirt':
        colorCode = '#a54400';
        break;
      case 'gold':
        colorCode = '#D4AF37';
        break;
      case 'gray':
        colorCode = '#808080';
        break;
      case 'grey':
        colorCode = '#808080';
        break;
      case 'lime':
        colorCode = '#00ff00';
        break;
      case 'navy':
        colorCode = '#000080';
        break;
      case 'nude':
        colorCode = '#E3BC9A';
        break;
      case 'mint':
        colorCode = '#b6e4d0';
        break;
      case 'milk':
        colorCode = '#f6f2e8';
        break;
      case 'wine':
        colorCode = '#533230';
        break;
      case 'coal':
        colorCode = '#060d11';
        break;
      case 'snow':
        colorCode = '#dddddd';
        break;
      case 'dash':
        colorCode = '#234d90';
        break;
      case 'moss':
        colorCode = '#40592f';
        break;
      case 'peel':
        colorCode = '#ffd322';
        break;
      case 'sand':
        colorCode = '#e0c389';
        break;
      case 'onyx':
        colorCode = '#323737';
        break;
      case 'silk':
        colorCode = '#d1c4bb';
        break;
      case 'peru':
        colorCode = '#cd853f';
        break;
      case 'pink':
        colorCode = '#ffc0cb';
        break;
      case 'plum':
        colorCode = '#8a3340';
        break;
      case 'rust':
        colorCode = '#b7410e';
        break;
      case 'teal':
        colorCode = '#008080';
        break;
      case 'tile':
        colorCode = '#b9b6a1';
        break;
      case 'azure':
        colorCode = '#f0ffff';
        break;
      case 'beige':
        colorCode = '#f5f5dc';
        break;
      case 'black':
        colorCode = '#000000';
        break;
      case 'brown':
        colorCode = '#804020';
        break;
      case 'cream':
        colorCode = '#ddd7cb';
        break;
      case 'terra':
        colorCode = '#b7a282';
        break;
      case 'slate':
        colorCode = '#4f4f4f';
        break;
      case 'olive':
        colorCode = '#40483f';
        break;
      case 'coral':
        colorCode = '#ff7f50';
        break;
      case 'green':
        colorCode = '#008000';
        break;
      case 'ivory':
        colorCode = '#f5ecda';
        break;
      case 'khaki':
        colorCode = '#f0e68c';
        break;
      case 'linen':
        colorCode = '#faf0e6';
        break;
      case 'mauve':
        colorCode = '#e0b0ff';
        break;
      case 'wheat':
        colorCode = '#f5deb3';
        break;
      case 'white':
        colorCode = '#ffffff';
        break;
      case 'sienna':
        colorCode = '#9f6a51';
        break;
      case 'bisque':
        colorCode = '#ffe4c4';
        break;
      case 'indigo':
        colorCode = '#4b0082';
        break;
      case 'maroon':
        colorCode = '#800000';
        break;
      case 'orange':
        colorCode = '#ffa500';
        break;
      case 'orchid':
        colorCode = '#da70d6';
        break;
      case 'purple':
        colorCode = '#800080';
        break;
      case 'salmon':
        colorCode = '#fa8072';
        break;
      case 'silver':
        colorCode = '#c0c0c0';
        break;
      case 'shadow':
        colorCode = '#5c534f';
        break;
      case 'tomato':
        colorCode = '#ff6347';
        break;
      case 'violet':
        colorCode = '#ee82ee';
        break;
      case 'yellow':
        colorCode = '#ffff00';
        break;
      case 'natural':
        colorCode = '#b7ac9a';
        break;
      case 'crimson':
        colorCode = '#dc143c';
        break;
      case 'fuchsia':
        colorCode = '#ff00ff';
        break;
      case 'magenta':
        colorCode = '#ff00ff';
        break;
      case 'thistle':
        colorCode = '#d8bfd8';
        break;
      case 'hot pink':
        colorCode = '#ff69b4';
        break;
      case 'sky blue':
        colorCode = '#87ceeb';
        break;
      case 'dark red':
        colorCode = '#8b0000';
        break;
      case 'cornsilk':
        colorCode = '#fff8dc';
        break;
      case 'honeydew':
        colorCode = '#f0fff0';
        break;
      case 'lavender':
        colorCode = '#e6e6fa';
        break;
      case 'moccasin':
        colorCode = '#ffe4b5';
        break;
      case 'midnight':
        colorCode = '#383863';
        break;
      case 'seashell':
        colorCode = '#fff5ee';
        break;
      case 'sea green':
        colorCode = '#2e8b57';
        break;
      case 'rose gold':
        colorCode = '#cf9fa6';
        break;
      case 'dark blue':
        colorCode = '#00008b';
        break;
      case 'dark cyan':
        colorCode = '#008b8b';
        break;
      case 'cool grey':
        colorCode = '#b9c1c9';
        break;
      case 'dark gray':
        colorCode = '#a9a9a9';
        break;
      case 'dark grey':
        colorCode = '#a9a9a9';
        break;
      case 'deep pink':
        colorCode = '#ff1493';
        break;
      case 'chocolate':
        colorCode = '#d2691e';
        break;
      case 'gainsboro':
        colorCode = '#dcdcdc';
        break;
      case 'steelblue':
        colorCode = '#4682b4';
        break;
      case 'turquoise':
        colorCode = '#40e0d0';
        break;
      case 'alabaster':
        colorCode = '#e8e7df';
        break;
      case 'dark green':
        colorCode = '#006400';
        break;
      case 'dark khaki':
        colorCode = '#bdb76b';
        break;
      case 'light blue':
        colorCode = '#add8e6';
        break;
      case 'light cyan':
        colorCode = '#e0ffff';
        break;
      case 'light gray':
        colorCode = '#d3d3d3';
        break;
      case 'light grey':
        colorCode = '#d3d3d3';
        break;
      case 'light pink':
        colorCode = '#ffb6c1';
        break;
      case 'lime green':
        colorCode = '#32cd32';
        break;
      case 'mint cream':
        colorCode = '#f5fffa';
        break;
      case 'royal blue':
        colorCode = '#4169e1';
        break;
      case 'slate blue':
        colorCode = '#6a5acd';
        break;
      case 'slate gray':
        colorCode = '#708090';
        break;
      case 'slate grey':
        colorCode = '#708090';
        break;
      case 'aquamarine':
        colorCode = '#7fffd4';
        break;
      case 'chartreuse':
        colorCode = '#7fff00';
        break;
      case 'dark orange':
        colorCode = '#ff8c00';
        break;
      case 'dark salmon':
        colorCode = '#e9967a';
        break;
      case 'dark violet':
        colorCode = '#9400d3';
        break;
      case 'light coral':
        colorCode = '#f08080';
        break;
      case 'light green':
        colorCode = '#90ee90';
        break;
      // Add more colors as needed
      default:
        colorCode = '#ccc'; // Default color if no match
    }

    label.style.backgroundColor = colorCode;
  });
});


  } catch(e) { console.error(e); }
})();
})();
